import cloneDeep from 'lodash/cloneDeep';

export default ({ app }, inject) => {
    inject('cloneDeep', cloneDeep);
};
